import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultSeriesPage from './Pages/DefaultSeriesPage';
import WizardPage from './Pages/WizardPage';

const SeriesInventoryRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:seriesId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultSeriesPage />
            </Route>
        </Switch>
        
    );
};

export default SeriesInventoryRouter;
